var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18C5 16.3431 6.567 15 8.5 15C10.433 15 12 16.3431 12 18M4 3.5V2.66667C4 1.74619 4.74619 1 5.66667 1H17.3333C18.2538 1 19 1.74619 19 2.66667V14.3333C19 15.2538 18.2538 16 17.3333 16H16.5M11 9.5C11 10.8807 9.88071 12 8.5 12C7.11929 12 6 10.8807 6 9.5C6 8.11929 7.11929 7 8.5 7C9.88071 7 11 8.11929 11 9.5ZM2.66667 19H14.3333C15.2538 19 16 18.2538 16 17.3333V5.66667C16 4.74619 15.2538 4 14.3333 4H2.66667C1.74619 4 1 4.74619 1 5.66667V17.3333C1 18.2538 1.74619 19 2.66667 19Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.0dd755cf13e98475e86ccd4be818233e.svg";
export { ForwardRef as ReactComponent };